const $$splitComponentImporter = () => import('/vercel/path0/src/routes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { useMemo } from "react";
import { createFileRoute } from "@tanstack/react-router";
import type { PokemonAdapted } from "@/domain/entities/pokemon";
export const Route = createFileRoute("/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});